import type { FC } from 'react';
import { useEffect, useState, Fragment } from 'react';
import { Picture } from '@ui';
import { checkOk, checkPlus } from '@images';
import API from '@api';
import './index.scss';

interface LeaveFeedBackFormConsAndProsProps {
  tags?: Array<{ id: string | number }>;
  activeTab: string;
  isRatingGood?: boolean;
  isMobile?: boolean;
  getDataFromForm: (payload: { field: string; value: number[] }) => void;
}

const LeaveFeedBackFormConsAndPros: FC<LeaveFeedBackFormConsAndProsProps> = ({
  tags = [],
  activeTab,
  isRatingGood,
  isMobile,
  getDataFromForm
}) => {
  const [tagList, setTagList] = useState<any[]>([]);
  const [listThingsToRender, setListThingsToRender] = useState<any[]>([]);
  useEffect(() => {
    API.getReviewTagList({}).then(res => {
      const tagArray = res.getReviewTagList?.map(item => {
        const itemType = (item.type ?? '').split('_');
        let isChecked = false;
        if (tags?.length > 0 && tags.find(i => i.id === item.id)) {
          isChecked = true;
        }
        return {
          ...item,
          isChecked,
          tab: itemType[0],
          reviewType: itemType[1]
        };
      });
      setTagList(tagArray ?? []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectList = (): any[] => {
    if (isRatingGood) {
      if (activeTab === 'review-shop') {
        return tagList.filter(
          item => item.tab === 'shop' && item.reviewType === 'positive'
        );
      } else {
        return tagList.filter(
          item => item.tab === 'delivery' && item.reviewType === 'positive'
        );
      }
    } else {
      if (activeTab === 'review-shop') {
        return tagList.filter(
          item => item.tab === 'shop' && item.reviewType === 'negative'
        );
      } else {
        return tagList.filter(
          item => item.tab === 'delivery' && item.reviewType === 'negative'
        );
      }
    }
  };

  useEffect(() => {
    setListThingsToRender(selectList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, isRatingGood, tagList]);

  useEffect(() => {
    const prosAndConsToSubmit = listThingsToRender
      .filter(item => item.isChecked)
      ?.map(item => +item.id);
    getDataFromForm({ field: 'prosAndCons', value: prosAndConsToSubmit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listThingsToRender]);

  const onListThingClickHandler = (title: string): void => {
    const newArr = listThingsToRender?.map(item => {
      if (item.title === title) {
        return { ...item, isChecked: !item.isChecked };
      }
      return item;
    });
    setListThingsToRender(newArr);
  };
  const lastItemFirstRow = activeTab === 'review-shop' ? 4 : 3;
  const lastItemSecondRow =
    listThingsToRender.length - lastItemFirstRow <= 3
      ? listThingsToRender.length + lastItemFirstRow
      : 3 + lastItemFirstRow;
  const firstRowStyle = {
    gridTemplateColumns: `repeat(${lastItemFirstRow}, auto)`
  };
  const secondRowStyle = {
    gridTemplateColumns: `repeat(${
      listThingsToRender.length - lastItemFirstRow <= 3
        ? listThingsToRender.length - lastItemFirstRow
        : 3
    }, auto)`
  };
  const thirdRowStyle = {
    gridTemplateColumns: `repeat(${
      listThingsToRender.length - lastItemSecondRow <= 3 ? 2 : 3
    }, auto)`
  };

  return (
    <div className='LeaveFeedBackFormConsAndPros'>
      {isMobile && (
        <p className='LeaveFeedBackFormConsAndPros__heading'>
          {isRatingGood ? 'Что особенно понравилось' : 'Что было не так'}
        </p>
      )}
      {isMobile && (
        <>
          <div className='LeaveFeedBackFormConsAndPros__wrapper'>
            {listThingsToRender?.map(item => (
              <div
                key={item.title}
                onClick={() => onListThingClickHandler(item.title)}
                className={`LeaveFeedBackFormConsAndPros__box${
                  item.isChecked
                    ? ' LeaveFeedBackFormConsAndPros__box--checked'
                    : ''
                }`}
              >
                <Picture
                  className='LeaveFeedBackFormConsAndPros__box__icon'
                  icon={item.isChecked ? checkOk : checkPlus}
                  height='10'
                  width='10'
                />
                <p className='LeaveFeedBackFormConsAndPros__box__text'>
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
      {!isMobile &&
        [
          { firstIndex: 0, lastIndex: lastItemFirstRow, style: firstRowStyle },
          {
            firstIndex: lastItemFirstRow,
            lastIndex: lastItemSecondRow,
            style: secondRowStyle
          },
          {
            firstIndex: lastItemSecondRow,
            lastIndex: listThingsToRender.length,
            style: thirdRowStyle
          }
        ]?.map((i, index) => (
          <Fragment key={`${i.style.gridTemplateColumns}-${index}`}>
            <div
              className='LeaveFeedBackFormConsAndPros__wrapper'
              style={i.style}
            >
              {listThingsToRender
                .slice(i.firstIndex, i.lastIndex)
                ?.map(item => (
                  <div
                    key={item.title}
                    onClick={() => onListThingClickHandler(item.title)}
                    className={`LeaveFeedBackFormConsAndPros__box${
                      item.isChecked
                        ? ' LeaveFeedBackFormConsAndPros__box--checked'
                        : ''
                    }`}
                  >
                    <Picture
                      className='LeaveFeedBackFormConsAndPros__box__icon'
                      icon={item.isChecked ? checkOk : checkPlus}
                      height='10'
                      width='10'
                    />
                    <p className='LeaveFeedBackFormConsAndPros__box__text'>
                      {item.title}
                    </p>
                  </div>
                ))}
            </div>
          </Fragment>
        ))}
    </div>
  );
};

export default LeaveFeedBackFormConsAndPros;
